import { TooltipItem } from "chart.js";
import { currencyFormatter } from "./formatting";
import { PaymentFrequency } from "src/generated/graphql";

export const PATH_NAMES = {
  ENROLL: "enroll",
  MY_CALENDAR: "my_calendar",
  CONFIRMATION: "confirmation",
  AGREEMENT_OVERVIEW: "agreement_overview",
  AGREEMENT_DOCUMENT: "agreement_document",
  AGREEMENT_CHECKOUT: `agreement_checkout`,
  LOGIN: "login",
  SINDRO: "sindro",
  SIGN_NOW: "sign_now",

  SERVICES: "services",
  LOCATION_SERVICES: "location_services",
  SESSION: "session",
  LOCATION_SESSION: "location_session",
  GENERAL_LOC: "general_loc",
};

export const ROUTES = {
  HOME: "/home",
  DASHBOARD: "/dashboard",
  REPORTS: "/reports",
  REPORT_REVENUE: "/dashboard/report-revenue",
  REPORT_POS: "/dashboard/report-pos",
  REPORT_AGREEMENT: "/dashboard/report-agreement",
  REPORT_PACKAGE: "/dashboard/report-package",
  LOCATION: "/locations",
  LOCATION_ID: "/locations/:locId",
  ORGANIZATION: "/organization",
  ORGANIZATION_ID: "/organization/:orgId",
  POLICY: "/policies",
  POLICY_ID: "/policies/:policyId",
  EMPLOYEE: "/employees",
  EMPLOYEE_ID: "/employees/:empId",
  ROOM: "/rooms",
  SERVICE: `/${PATH_NAMES.SERVICES}`,
  SERVICE_ID: `/${PATH_NAMES.SERVICES}/:serviceId`,
  LOCATION_SERVICE: `/${PATH_NAMES.LOCATION_SERVICES}`,
  LOCATION_SERVICE_ID: `/${PATH_NAMES.LOCATION_SERVICES}/:serviceId`,
  SESSION: `/${PATH_NAMES.SESSION}`,
  LOCATION_SESSION: `/${PATH_NAMES.LOCATION_SESSION}`,
  SESSION_ID: `/${PATH_NAMES.SESSION}/:sessionId`,
  LOCATION_SESSION_ID: `/${PATH_NAMES.LOCATION_SESSION}/:sessionId`,
  TIME_CLOCK: "/time_clock",
  DISCOUNTS: "/discounts",
  STATIONS: "/stations",
  CLIENT: "/accounts",
  CLIENT_ID: "/accounts/:clientId",
  GUEST: "/accounts/guest",
  GUEST_ID: "/accounts/guest/:clientId",
  LEAD: "/accounts/lead",
  LEAD_ID: "/accounts/lead/:clientId",
  ORG_AGREEMENT: "/org/agreement",
  ORG_AGREEMENT_ID: "/org/agreement/:agreementId",
  AGREEMENT: "/agreement",
  AGREEMENT_ID: "/agreement/:agreementId",
  ORG_PACKAGE: "/org/package",
  ORG_PACKAGE_ID: "/org/package/:pkgId",
  PACKAGE: "/package",
  PACKAGE_ID: "/package/:pkgId",
  CALENDER: "/calendar",
  CALENDER_RECURRING_EVENT: "/calendar_recurring",
  DISCOUNTS_ID: "/discounts/:discId",
  PRODUCT: "/product",
  PRODUCT_ID: "/product/:groupId",
  REQUESTS: "/requests",
  ROLES: "/roles",
};

// No Auth Routes
export const PUBLIC_ROUTES = {
  ORG_LOGIN: `/:orgId/${PATH_NAMES.LOGIN}`,
  CLIENT_LOGIN: `/${PATH_NAMES.SINDRO}/:orgId`,
  MEMBERSHIPS: "/:locationId/memberships/:orgId",
  SIGN_NOW: "/sign_now/:docGroupId",
};

export const ROUTE_NAMES = {
  LOCATION: "Locations",
  LOCATION_ID: "Location Detail",
  ORGANIZATION: "Organizations",
  ORGANIZATION_ID: "Location Detail",
  POLICY: "Policies",
  POLICY_ID: "Policy Detail",
  EMPLOYEE: "Employees",
  EMPLOYEE_ID: "Employee Detail",
  ROOM: "Rooms",
  SERVICE: "Services",
  SERVICE_ID: "Service Detail",
  TIME_CLOCK: "Time Clock Management",
  STATIONS: "Station Management",
  DISCOUNTS: "Discounts",
  CLIENT: "Accounts",
  CLIENT_DETAIL: "Account Detail",
  AGREEMENT: "Agreements",
  AGREEMENT_DETAIL: "Agreement Detail",
  ORG_AGREEMENT: "Organization Agreements",
  PACKAGE: "Packages",
  PACKAGE_DETAIL: "Package Detail",
  ORG_PACKAGE: "Organization Packages",
  CALENDER: "Calendar",
  CALENDER_RECURRING_EVENTS: "Recurring Events",
  DISCOUNTS_ID: "Discounts Detail",
  PRODUCT: "Products",
  PRODUCT_DETAIL: "Product Detail",
  DASHBOARD: "Dashboard",
  REPORTS: "Reports",
  REPORT_REVENUE: "Revenue Report",
  REPORT_POS: "Point of Sale Report",
  REPORT_AGREEMENT: "Agreement Report",
  REPORT_PACKAGE: "Package Report",
  GUEST_DETAIL: "Guest Detail",
  LEAD_DETAIL: "Lead Detail",
  REQUESTS: "Requests",
};

export const TAB_LIST = {
  HOME: "Home",
  DASHBOARD: "Dashboard",
  REPORTS: "Reports",
  LOCATION: "Locations",
  GENERAL: "General",
  ORGANIZATION: "Organization",
  POLICY: "Policies",
  EMPLOYEE: "Employees",
  ROOM: "Rooms",
  LOC_GENERAL: "General",
  SERVICE: "Services",
  LOCATION_SERVICE: "Services ",
  TIME_CLOCK: "Time Clock",
  STATIONS: "Stations",
  DISCOUNTS: "Discounts",
  CLIENT: "Accounts",
  AGREEMENT: "Agreements",
  PACKAGE: "Packages",
  ORG_GENERAL: "General",
  ORG_AGREEMENT: "Org Agreements",
  ORG_PACKAGE: "Org Packages",
  CALENDER: "Calendar",
  CALENDER_RECURRING_EVENTS: "Recurring Events",
  PRODUCT: "Products",
  REQUESTS: "Requests",
  ROLES: "Roles",
};

let clientPath = "sindro/:org";

export const setClientPath = (organizationId: string) => {
  clientPath = `sindro/${organizationId}`;
};

export const CLIENT_ROUTES = {
  HOME: "home",
  PROFILE: "profile",
  EDIT_PROFILE: "edit_profile",

  MY_CALENDAR: PATH_NAMES.MY_CALENDAR,
  MY_CALENDAR_ID: `${PATH_NAMES.MY_CALENDAR}/:meetingId`,
  SCHEDULE_LOCATION: `${PATH_NAMES.MY_CALENDAR}/location`,
  SCHEDULE_TYPE: `${PATH_NAMES.MY_CALENDAR}/type`,
  SCHEDULE_EVENTS: `${PATH_NAMES.MY_CALENDAR}/events`,
  EVENT_SCHEDULE_ID: `${PATH_NAMES.MY_CALENDAR}/${PATH_NAMES.ENROLL}/:meetingId`,
  EVENT_CONFIRMATION_ID: `${PATH_NAMES.MY_CALENDAR}/${PATH_NAMES.CONFIRMATION}/:meetingId`,

  SHOPPING_CART: "shoppingCart",
  CHECKOUT: "checkout",

  MY_ACCOUNTS: "accounts",
  MY_RECORDS: "records",
  GROUP_CLIENTS: "group",
  PAYMENT_METHODS: "payment_methods",

  AGREEMENT_OVERVIEW: `${PATH_NAMES.AGREEMENT_OVERVIEW}/:locationOfferingId`,
  AGREEMENT_DOCUMENT: `${PATH_NAMES.AGREEMENT_DOCUMENT}/:signedAgreementId`,
  AGREEMENT_CHECKOUT: `${PATH_NAMES.AGREEMENT_CHECKOUT}/:signedAgreementId`,
};

export const CLIENT_TAB_LIST = {
  HOME: "Home",
  PROFILE: "Profile",
  EDIT_PROFILE: "Edit Profile Info",
  MY_CALENDAR: "My Calendar",
  SCEDULE_EVENT: "Schedule an Event",
  SHOPPING_CART: "Shopping Cart",
  CHECKOUT: "Checkout",
  MY_ACCOUNTS: "My Accounts",
  MY_RECORDS: "My Records",
  PAYMENT_METHODS: "Payment Methods",
  GROUPS: "Groups",
  LOGOUT: "Logout",
  AGREEMENT_OVERVIEW: "Agreement Overview",
  AGREEMENT_CHECKOUT: "Agreement Checkout",
};

export const MESSAGES = {
  UNSAVED_CHANGES: "You have unsaved changes!",
  NO_DATA: "No Data Found",
  INVALID_CSV: "Invalid Csv Format!",
  UPLOADED_FILE: "File Uploaded Successfully!",

  //Delete messages
  DEL_CONFIRM_MSG:
    "You may not be able to recover this item once deleted. Are you sure you want to delete",
  CONFIRM_DEL: "Confirm Delete",
};

export const weeksArray = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export enum ModalStages {
  AGREEMENTS = "Agreements",
  AGREEMENTGROUPS = "AgreementGroups",
  AGREEMENTOVERVIEW = "AgreementOverview",
  SIGNPOLICIES = "SignPolicies",
  DEVICEUNLOCK = "DeviceUnlock",
  PAYMENTMETHOD = "PaymentMethod",
  CONFIRMATION = "Confirm",
}

export function ordinal_suffix_of(i: number) {
  let suffix = "th";
  if (i < 4 || i > 20) {
    let lastDigit = i % 10;
    if (lastDigit == 1) {
      suffix = "st";
    } else if (lastDigit == 2) {
      suffix = "nd";
    } else if (lastDigit == 3) {
      suffix = "rd";
    }
  }
  return i + suffix;
}
export const daysArray = Array(28)
  .fill(0)
  .map((_, i) => ordinal_suffix_of(i + 1));

export const monthArray = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const enum HeightCard {
  xs = 30,
  sm = 34,
  md = 40,
  lg = 44,
}

export const enum CardRadius {
  xs = 4,
  sm = 6,
  md = 8,
  lg = 12,
}

export enum CalendarView {
  Month = "month",
  Week = "week",
  Day = "day",
}

export enum MeetingTypes {
  Waitlistee = "Waitlistee",
  Attendee = "Attendee",
}

export function generateUniqueColors(
  count: number,
  target?: number,
  sigma?: number
) {
  const colors = [];
  if (target && sigma) {
    const hueStep = sigma / count;

    let offset = Math.floor(-count / 2);
    for (let i = 0; i < count; i++) {
      const hue = (i + offset) * hueStep + target;
      const color = `hsl(${hue}, 78%, 60%)`;
      colors.push(color);
    }
  } else {
    const hueStep = 360 / count;

    for (let i = 0; i < count; i++) {
      const hue = (i * hueStep) % 360;
      const color = `hsl(${hue}, 90%, 35%)`;
      colors.push(color);
    }
  }

  return colors;
}

export const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "right" as const,
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
      },
    },
  },
};

export const currencyTooltipPlugin = {
  tooltip: {
    callbacks: {
      label: function (context: TooltipItem<"doughnut">) {
        let label = context.dataset.label || "";

        if (label) {
          label += ": ";
        }
        if (context.parsed.valueOf() !== null) {
          label += currencyFormatter.format(context.parsed.valueOf());
        }
        return label;
      },
    },
  },
};

export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export enum CartType {
  add = "add",
  subtract = "subtract",
}

export const defaultPagination = {
  filters: [],
};

export function groupByDate<T>(
  data: T[],
  getDate: (item: T) => string,
  sort?: "ASC" | "DSC"
): T[][] {
  const groupedMap = new Map<string, T[]>();

  data.forEach((item) => {
    const dateWithoutTime = new Date(getDate(item)).toLocaleDateString();
    if (!groupedMap.has(dateWithoutTime)) {
      groupedMap.set(dateWithoutTime, []);
    }
    groupedMap.get(dateWithoutTime)?.push(item);
  });

  let sortedGroups = Array.from(groupedMap.entries());
  if (sort) {
    return sortedGroups
      .sort(([dateA], [dateB]) =>
        sort === "ASC"
          ? new Date(dateA).getTime() - new Date(dateB).getTime()
          : new Date(dateB).getTime() - new Date(dateA).getTime()
      )
      .map(([_, group]) => group);
  } else {
    return sortedGroups.map(([_, group]) => group);
  }
}

export const enum ModalId {
  CheckInSelectMember = "check-in-member",
  CheckInModalId = "checkIn-modal",
  CatalogModalId = "catalog-modal",

  AddNote = "add-note",
  EditNote = "edit-note",

  CheckoutCustomer = "customer-checkout",
  CheckoutPayment = "customer-payment",
  CreateGuest = "create-guest",
  SelectTerminal = "select-terminal",

  DeleteReason = "delete-reason",
  AddReason = "add-reason",
  EditReason = "edit-reason",
  DeleteTransition = "delete-transition",

  ReportView = "report-view",
  CreatePolicy = "create-policy",
}

export const enum StorageKeyName {
  OrgLoginId = "orgLoginId",
  LocationOfferingId = "locationOfferingId",
  LocationId = "locationId",
  ShoppingCartId = "shoppingCartId",
}

export const enum CRUDSTATES {
  Create = "Create",
  Update = "Update",
  Delete = "Delete",
}

export const ShoppingCartMethods = {
  get: (): string | null => {
    return sessionStorage.getItem(StorageKeyName.ShoppingCartId);
  },

  set: (value: string) => {
    sessionStorage.setItem(StorageKeyName.ShoppingCartId, value);
  },

  remove: () => {
    sessionStorage.removeItem(StorageKeyName.ShoppingCartId);
  },
};

export const removeOrgLoginId = () =>
  localStorage.removeItem(StorageKeyName.OrgLoginId);

export const ClientCardBg = "#F0F0F0bb";

const DIRECTION_ASC = "ASC";
export const DEFAULT_ORDER = {
  name: {
    field: "name",
    direction: DIRECTION_ASC,
  },
  firstName: {
    field: "firstName",
    direction: DIRECTION_ASC,
  },
  agreement_name: {
    field: "agreement_name",
    direction: DIRECTION_ASC,
  },
  package_name: {
    field: "package_name",
    direction: DIRECTION_ASC,
  },
  productGroup_name: {
    field: "productGroup_name",
    direction: DIRECTION_ASC,
  },
  organizationservice_name: {
    field: "organizationservice_name",
    direction: DIRECTION_ASC,
  },
  PrivateSession_name: {
    field: "PrivateSession_name",
    direction: DIRECTION_ASC,
  },
  meetingSeries_name: {
    field: "meetingSeries_name",
    direction: DIRECTION_ASC,
  },
  client_name: {
    field: "client_name",
    direction: DIRECTION_ASC,
  },
  revenueCat_name: {
    field: "revenueCat_name",
    direction: DIRECTION_ASC,
  },
};

export const TIMEZONES = [
  { name: "Alaska Time", value: "America/Anchorage" },
  { name: "Central Time", value: "America/Chicago" },
  { name: "Eastern Time", value: "America/New_York" },
  { name: "Hawaii Time", value: "Pacific/Honolulu" },
  { name: "Mountain Time", value: "America/Denver" },
  { name: "Pacific Time", value: "America/Los_Angeles" },
];

export const Hours = [
  { name: "12 AM", value: "0" },
  { name: "1 AM", value: "1" },
  { name: "2 AM", value: "2" },
  { name: "3 AM", value: "3" },
  { name: "4 AM", value: "4" },
  { name: "5 AM", value: "5" },
  { name: "6 AM", value: "6" },
  { name: "7 AM", value: "7" },
  { name: "8 AM", value: "8" },
  { name: "9 AM", value: "9" },
  { name: "10 AM", value: "10" },
  { name: "11 AM", value: "11" },
  { name: "12 PM", value: "12" },
  { name: "1 PM", value: "13" },
  { name: "2 PM", value: "14" },
  { name: "3 PM", value: "15" },
  { name: "4 PM", value: "16" },
  { name: "5 PM", value: "17" },
  { name: "6 PM", value: "18" },
  { name: "7 PM", value: "19" },
  { name: "8 PM", value: "20" },
  { name: "9 PM", value: "21" },
  { name: "10 PM", value: "22" },
  { name: "11 PM", value: "23" },
];

export const SHOW_TYPE_PAY = {
  [PaymentFrequency.BiWeekly]: "Weeks",
  [PaymentFrequency.Weekly]: "Weeks",
  [PaymentFrequency.Monthly]: "Months",
  [PaymentFrequency.Yearly]: "Years",
};

export enum EMPLOYEE_ROLE_OBJ {
  calendar = "calendar",
  catalog = "catalog",
  checkInQueue = "checkInQueue",
  clients = "clients",
  locAgreements = "locAgreements",
  locDashboard = "locDashboard",
  locDiscounts = "locDiscounts",
  locEmployees = "locEmployees",
  locPackages = "locPackages",
  locPolicies = "locPolicies",
  locProducts = "locProducts",
  locReports = "locReports",
  locRequests = "locRequests",
  locRooms = "locRooms",
  locServices = "locServices",
  locSettings = "locSettings",
  locTimeclock = "locTimeclock",
  orgAgreements = "orgAgreements",
  orgDiscounts = "orgDiscounts",
  orgLocations = "orgLocations",
  orgPackages = "orgPackages",
  orgPolicies = "orgPolicies",
  orgRoles = "orgRoles",
  orgService = "orgService",
  orgSettings = "orgSettings",
  personalTimeClock = "personalTimeClock",
  employeeStations = "employeeStations",
}

export const MigrationModalStyle = {
  styles: {
    modal: {
      width: "auto",
    },
  },
};

export const fullScreenModalCss = {
  body: {
    padding: 0,
  },
  root: {
    marginTop: 58,
    zIndex: 99,
  },
  header: {
    display: "none",
  },
};
